import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { Box, Grid } from "@mui/material";
import * as Yup from 'yup'
import { useFormik } from "formik";
import { clearPhaseList, fetchHospitalList, fetchPhaseList, fetchProductList, selectBmrAllProductList, selectBmrOnBoardUserLoading } from "../../../bmr/slices/onBoardUser";
import { fetchAllRoles } from "../../../bmr/slices/roles";
import FormikControl from "../../../bmr/components/common/FormikControl";

const validationSchema = Yup.object().shape({
    template: Yup.string()
        .required("Template is required"),
    type: Yup.string()
        .required("Type is required"),
    version: Yup.string()
        .required("Version number is required"),
    approval_level: Yup.number().required("Approval level is required"),
});

const AssignNewPermission = ({ editId }) => {
    const dispatch = useDispatch()
    const allProductList = useSelector(selectBmrAllProductList)
    const isLoading = useSelector(selectBmrOnBoardUserLoading)

    const initialValues = {
        template: "",
        type: "",
        version: "",
        approval_level: "",
    };
    const handleSubmit = async (values) => {
        console.log("VVV", values) //@info static handlesubmit call
    }
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true,
    })

    useEffect(() => {
        getRoles()
    }, [])

    const getRoles = async () => {
        await dispatch(fetchProductList())
        if (!editId) {
            await dispatch(clearPhaseList());
        }
        await dispatch(fetchAllRoles())
        await dispatch(fetchHospitalList())
    }

    useEffect(() => {
        const getPhaseList = async () => {
            if (formik.values.product_id?.length > 0) {
                await dispatch(fetchPhaseList({ product_id: formik.values.product_id.join(","), role_id: formik.values.role_id }));
            } else {
                if (!editId) {
                    await dispatch(clearPhaseList());
                }
            }
        };

        if (allProductList?.length > 0) {
            getPhaseList();
        }
    }, [formik.values.product_id, allProductList, dispatch, editId]);

const generateApprovalLevels = (levelCount) => {
  if (!levelCount || levelCount < 1) return [];
  
//   const levels = [];
  
  // Generate array of approval level numbers [1, 2, 3, ...]
  const levelNumbers = Array.from({ length: levelCount }, (_, i) => i + 1);
  
  // Create approval fields for each level
  const approvalFields = levelNumbers.map((level) => {
    const isFirstLevel = level === 1;
    const ordinal = level === 1 ? 'First' : level === 2 ? 'Second' : level === 3 ? 'Third' : `${level}th`;
    
    return {
      label: `${ordinal} Level Approval${isFirstLevel ? '*' : ''}`,
      name: `approval_${level}`,
      placeholder: 'Select role',
      type: 'select',
      options: [],
      required: isFirstLevel // Only first level is required
    };
  });
  
  // Create section configuration
  const approvalSection = {
    section: `Roles for ${levelCount}-Level Approval`,
    inLine: approvalFields
  };
  
  return [approvalSection];
};

const formOptions = [
  {
    label: 'Template',
    type: 'select',
    name: 'template',
    required: true,
    disabled: false,
    placeholder: "Select template",
    options: []
  },
  {
    label: 'Type',
    type: 'select',
    name: 'type',
    required: true,
    placeholder: 'Select Type',
    options: []
  },
  {
    label: 'Versions',
    type: 'select',
    name: 'version',
    required: true,
    placeholder: 'Select version',
    options: []
  },
  {
    label: 'Approval Level',
    type: 'select',
    name: 'approval_level',
    required: true,
    placeholder: 'Select approval level',
    options: Array.from({ length: 10 }, (_, i) => ({
      label: `${i + 1} level approval`,
      value: `${i + 1}`
    }))
  },
  ...(formik.values?.approval_level ? 
      generateApprovalLevels(parseInt(formik.values.approval_level)) 
      : []
  )
];
    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => {
                        // If it's a section header with inline fields
                        if (props.section && props.inLine) {
                            return (
                                <Grid key={key} item xs={12}>
                                    <strong className="!pb-3 block">{props.section}</strong>
                                    <Box>
                                        {props.inLine.map((fieldProps, fieldKey) => (
                                            <Box key={fieldKey} >
                                                <FormikControl formik={formik} {...fieldProps} />
                                            </Box>
                                        ))}
                                    </Box>
                                </Grid>
                            );
                        }

                        // If it's just a section header
                        if (props.section) {
                            return (
                                <Grid key={key} item xs={12}>
                                    <strong className="!pb-3 block">{props.section}</strong>
                                </Grid>
                            );
                        }

                        // Otherwise, it's a regular form field
                        return (
                            <Grid key={key} item xs={12}>
                                <FormikControl formik={formik} {...props} />
                            </Grid>
                        );
                    })}
                </Grid>
                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton loading={isLoading} fullWidth type="submit" variant="contained">{editId ? "Update" : "Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default AssignNewPermission;